import createCachedSelector from 're-reselect'

const orderHistorySelector = (state: any, id: number) =>
  state.Orders.history[id] || {}

export const selectOrderHistory = createCachedSelector(
  orderHistorySelector,
  (history) => history,
)((_, id) => id)
